import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { global } from "../../Context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import _ from "lodash";
import axiosInstance from "../../config/axiosInterceptor";

const CoinPanelTransactionLists = () => {
  const [rechargeHistory, setRechargeHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const { uniqueId } = useParams();

  const handlePrevPage = () => setCurrentPage((prev) => prev - 1);
  const handleNextPage = () => setCurrentPage((prev) => prev + 1);
  const handleChangeItemsPerPage = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const rechargeHistoryssearch = async (value) => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL1}/coin/recharge/searchsendCoinHistory?userId=${uniqueId}&search=${value}`,
        { method: "GET" }
      );
      const response = await res.json();
      setRechargeHistory(response.history);
      setTotalItems(response.total);
      setTotalAmount(response.totalAmount || 0);
      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSearchChange = useCallback(
    _.debounce((value) => {
      setSearch(value);
      if (value !== "") {
        rechargeHistoryssearch(value);
      } else {
        rechargeHistorys({ userId: uniqueId });
      }
    }, 1000),
    [currentPage]
  );

  const rechargeHistorys = async (value) => {
    try {
      setLoading(true);
      const payload = {
        ...value,
        startDate: startDate ? `${startDate}T00:00:00` : undefined,
        endDate: endDate ? `${endDate}T23:59:59` : undefined,
      };
      const res = await fetch(
        `${process.env.REACT_APP_BASEURL3}/coin/recharge/history?page=${currentPage}&limit=${itemsPerPage}`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();
      setRechargeHistory(data.history);
      setTotalItems(data.total);
      setTotalAmount(data.totalAmount || 0);
      setLoading(false);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const submitHandler = async (dataDetails) => {
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL2}/admin/return/coins`,
        dataDetails
      );
      if (data.success === "1") {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    rechargeHistorys({ userId: uniqueId });
  }, [currentPage, itemsPerPage,startDate,endDate]);

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  return (
    <>
      <section className="content-header">
        <h1>Transaction Lists Sent To User</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Transactions</li>
        </ol>
      </section>

      <section className="content">
        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-xs-6">
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="col-xs-6">
            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-control"
            />
          </div>
        </div>

        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-xs-6">
            <button
              className="btn btn-primary"
              onClick={() => rechargeHistorys({ userId: uniqueId })}
            >
              Apply Filter
            </button>
          </div>
          <div className="col-xs-6 text-right">
            <div><b>Total Entries:</b> {totalItems}</div>
            <div><b>Total Amount:</b> {totalAmount}</div>
          </div>
        </div>

        <div className="row">
          <div className="pagination-options col-xs-6">
            <select
              className="form-control pagination-select"
              value={itemsPerPage}
              onChange={handleChangeItemsPerPage}
            >
              <option value="10">10 per page</option>
              <option value="50">50 per page</option>
              <option value="100">100 per page</option>
              <option value="1000">1000 per page</option>
            </select>
          </div>
          <div className="main-data-single-field col-xs-6" style={{ width: "fit-content" }}>
            <span style={{ fontWeight: "bold", marginRight: "8px" }}>Search</span>
            <input
              type="text"
              name="pname"
              style={{ borderRadius: "4px", borderStyle: "groove", width: "150px" }}
              onChange={(e) => handleSearchChange(e.target.value)}
              placeholder="Search User"
            />
          </div>

          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Username</th>
                      <th>Coin</th>
                      <th>Date/Time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {loading ? (
                    <tbody><tr><td colSpan={5}>Loading...</td></tr></tbody>
                  ) : (
                    <tbody>
                      {rechargeHistory?.map((item, index) => {
                        const srNo = index + indexOfFirstItem + 1;
                        return (
                          <tr key={item._id}>
                            <td>{srNo}</td>
                            <td>{item?.userId}</td>
                            <td>
                              <label className="label label-success">{item?.coin}</label>
                            </td>
                            <td>{new Date(item?.createdAt).toLocaleString()}</td>
                            <td>
                              <button
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  fontWeight: "bold",
                                  border: "none",
                                  padding: ".3rem .5rem",
                                }}
                                onClick={() => {
                                  const confirm = window.confirm("Are you sure you want to return coin?");
                                  if (confirm) {
                                    submitHandler({ id: item._id });
                                  }
                                }}
                              >
                                Return
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </table>

                <div className="pagination-container">
                  <button
                    className="btn btn-default"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                  <div className="total-entries" style={{ float: "right", marginTop: "20px" }}>
                    Total entries: <b>{totalItems}</b>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoinPanelTransactionLists;
